import {useState} from "react"
import Box from "@mui/material/Box"
import SideMenu from "../../components/SideMenu"
import styles from "./MiniDrawer.module.scss"
import {useSelector} from "react-redux"
import SessionExpired from "../../components/SessionExpired"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faChevronRight, faChevronLeft} from "@fortawesome/pro-regular-svg-icons"
import Typography from "@mui/material/Typography"

export default function MiniDrawer({children}: any) {
    const [open, setOpen] = useState(false)
    const [hover, setHover] = useState(false)
    const [isIconHover, setIsIconHover] = useState(false)
    const {enableSessionExpired} = useSelector((store: any) => store.sessionExpired)
    const {enableFooter} = useSelector((store: any) => store.footer)

    return enableSessionExpired ? (
        <SessionExpired />
    ) : (
        <Box sx={{display: "flex", height: "100%", background: "#F9F9F9", position: "relative"}}>
            <SideMenu open={open} setHover={(value: any) => setHover(value)} isHover={hover} />
            <Box
                onClick={() => setOpen(!open)}
                onMouseEnter={() => setIsIconHover(true)}
                onMouseLeave={() => setIsIconHover(false)}
                className={
                    open
                        ? isIconHover
                            ? styles.minidrawer__open_icon_container__is_hover
                            : styles.minidrawer__open_icon_container
                        : !isIconHover
                        ? styles.minidrawer__close_icon_container
                        : styles.minidrawer__close_icon_container__is_hover
                }
            >
                <Box className={styles.minidrawer__arrow_icon_container}>
                    <FontAwesomeIcon
                        icon={faChevronRight}
                        style={
                            open
                                ? isIconHover
                                    ? {opacity: 0, transition: "0.1s ease-in", width: "0px", pointerEvents: "none"}
                                    : {opacity: 0, transition: "0.1s ease-in", width: "0px", pointerEvents: "none"}
                                : isIconHover
                                ? {opacity: 1, transition: "0.1s ease-in"}
                                : {opacity: 0, transition: "0.1s ease-in", width: "0px", pointerEvents: "none"}
                        }
                    />

                    <FontAwesomeIcon
                        icon={faChevronLeft}
                        style={
                            !open
                                ? isIconHover
                                    ? {opacity: 0, transition: "0.1s ease-in", width: "0px", pointerEvents: "none"}
                                    : {opacity: 0, transition: "0.1s ease-in", width: "0px", pointerEvents: "none"}
                                : isIconHover
                                ? {opacity: 1, transition: "0.1s ease-in"}
                                : {opacity: 0, transition: "0.1s ease-in", width: "0px", pointerEvents: "none"}
                        }
                    />
                </Box>
                <Box
                    className={
                        open
                            ? isIconHover
                                ? styles.minidrawer__open_icon_container__icon_text_container__is_hover
                                : styles.minidrawer__open_icon_container__icon_text_container
                            : !isIconHover
                            ? styles.minidrawer__close_icon_container__icon_text_container
                            : styles.minidrawer__close_icon_container__icon_text_container__is_hover
                    }
                >
                    <Typography variant="caption">
                        {open ? (isIconHover ? "Collapse" : "") : isIconHover ? "Expand" : ""}
                    </Typography>
                </Box>
            </Box>
            <Box component="main" sx={{flexGrow: 1, flexDirection: "column", overflow: "hidden"}}>
                <Box
                    component="div"
                    sx={
                        enableFooter
                            ? {p: "0px", background: "#F9F9F9", overflow: "scroll", height: "100%"}
                            : {
                                  p: "30px",
                                  background: "#F9F9F9",
                                  height: "100%",
                                  overflow: "scroll",
                              }
                    }
                >
                    {children}
                </Box>
            </Box>
        </Box>
    )
}
